import axios from 'axios';

import { authHeader } from '@H';

export default {
  getDealersList: (data) =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/users/dealers-list/?limit=${data.limit}&offset=${data.offset}&created_date=${data.start_date}&account_id=${data.account_id}&mobile_number=${data.contact}&omc_id=${data.omc_id}&bunk_name=${data.business_name}&first_name=${data.owner_name}&email=${data.email}&state=${data.state}&city=${data.city}&country_id=${data.country}`,
    }),
};
